<template>
  <div class="contain">
    <p>{{ this.body }}</p>
    <CardActions>
      <Button
        @click="hideModal"
        :label="this.$i18n.t('go_no_go_button_continue')"
      />
    </CardActions>
  </div>
</template>

<script>
import { Button, CardActions } from '@neurotrack/web-shared-components'
import { mapMutations } from 'vuex'
import { hideModal } from '@/store'

export default {
  name: 'LightFeedback',
  components: { Button, CardActions },
  props: {
    body: String
  },
  methods: {
    ...mapMutations([hideModal]),
    handleKeyboard(e) {
      if (e.code.toLowerCase() === 'space') {
        this.hideModal()
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyboard)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyboard)
  }
}
</script>

<style scoped>
p {
  text-align: center;
}
.contain {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
